// @ts-nocheck
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import general from '../images/blog2_1.png';
import Section0 from '../components/blogs/section0';
import Section2 from '../components/blogs/section2';
import HeaderBlog from '../components/blogs/headerBlog';
import SubheaderBlog from '../components/blogs/subheaderBlog';

const Blog1 = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <>
      <div className="container max-w-screen-lg pt-3 pb-20 ">
        <HeaderBlog text={
          "РОЗЗБРОЇТИ НАШІ СЕРЦЯ ЗАРАДИ МИРУ"
        } />
        <Section0 photo={general} />
        <Section2
          title={"Цього місяця ми особливо молимося за салезіянські спільноти, які живуть у зонах війни. Війни народжуються в серці людини й впливають на стосунки навіть усередині наших спільнот. Чи вважаєте ви, отче Тхатхіредді, що конфлікти в спільнотах - це нормально?"}
          text1={`
            Дякую вам за те, що обрали мир темою випуску Cagliero 11. У ці темні часи ми з особливою наполегливістю покликані молитися, як та вдова з Євангелія, щоб припинилися війни, які ранять і вбивають наших братів і сестер, нашу спільну людяність. Ми єднаємося в солідарності з нашими співбратами, які серед конфліктів і воєн у різних частинах світу мужньо продовжують бути поруч із молоддю та з тими, хто їм довірений.
            `}
          text2={`
            Конфлікти є невід’ємною частиною людського досвіду, і наші спільноти не є винятком. Те, що починається як проста різниця в поглядах, якщо з цим не працювати, може перерости в глибші непорозуміння та поділи. Керувати такими моментами із зрілістю, емпатією та смиренням є життєво необхідним для збереження гармонії та спільної мети.
            `} text3={undefined} />

        <Section2
          title={
            "Ви були Провінційним Настоятелем провінції Хайдарабад (Індія) і відповідальним за кілька спільнот, зокрема за Колле Дон Боско. Який досвід ви здобув у цих ролях щодо розв’язання конфліктів і примирення між співбратами?"
          }
          text1={
            `
            Я зрозумів, наскільки крихким і вразливим може бути мир у наших спільнотах. Навіть між співбратами, об’єднаними спільною місією та духовністю, розбіжності в думках, незагоєні рани й зруйновані очікування можуть непомітно зводити мури, що розділяють серця. У такі моменти я навчився, що першим актом примирення є не говоріння, а слухання: глибоке слухання з терпінням і розумінням. Справжнє слухання - це акт любові. Воно роззброює ворожість і дозволяє благодаті увійти. Коли ми наважуємося слухати поза словами, ми починаємо чути мовчазний крик про розуміння, що приховується за кожним конфліктом. Слухання стає порогом миру, мостом, на якому серця знову зустрічаються.
            `
          }
          text2={
            `
Також джерелом примирення була молитва. Бували моменти, коли діалог здавався неможливим, коли людські зусилля досягали своєї межі. У такі хвилини довірення ситуації та співбратів Господу відкривало простір, у якому благодать могла діяти там, де слова були безсилі. Мир не будується — його приймають. Лише тоді, коли ми відмовляємося від контролю, Божа ніжність може відновити те, що зруйнувала гординя. Прощення, зрештою, є найвищим виявом миру. Я бачив співбратів, які, незважаючи на глибокі рани, обирали безумовно прощати. Це приховані святі серед нас, будівничі невидимих святинь миру. Прощення - це не слабкість, а найвищий акт мужності та свободи.
            `
          }
          text3={undefined}
        />
        <Section2
          title={
            "Що б ви порадив, тим, хто молиться за мир у світі та в серцях людей?"
          }
          text1={
            `
Наша салезіянська місія кличе нас бути «знаками й носіями Божої любові», особливо для молоді, яка бачить довкола себе так багато конфліктів. Вони дивляться на нас, щоб побачити, чи справді братерство можливе. Коли вони бачать нас примиреними, радісними й єдиними в різноманітті, вони відкривають для себе мир, який обіцяє Христос, - мир, «якого світ дати не може». У світі, розтерзаному війною та ненавистю, наші скромні спільноти можуть стати оазами надії. Наші слова й наші вчинки можуть випромінювати мир, який зцілює поділи, відновлює довіру й оновлює серця.
            `
          }
          text2={undefined}
          text3={undefined}
        />
        <div className="flex justify-between py-10 italic font-semibold">
          <div>
            
          </div>

          <div>січень 2026 р.</div>
        </div>
      </div>
    </>
  );
};

export default Blog1;
